var _defs, _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gprocess02",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wprocess02",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oprocess02",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wprocess02)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#oprocess02)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 150,
    width: 600,
    height: 500,
    rx: 28,
    fill: "url(#gprocess02)",
    fillOpacity: 0.14,
    stroke: "#548A85",
    strokeOpacity: 0.45,
    strokeWidth: 1.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 150,
    x2: 450,
    y2: 650,
    stroke: "#548A85",
    strokeOpacity: 0.2,
    strokeDasharray: "4 10"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 150,
    x2: 600,
    y2: 650,
    stroke: "#548A85",
    strokeOpacity: 0.2,
    strokeDasharray: "4 10"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 150,
    x2: 750,
    y2: 650,
    stroke: "#548A85",
    strokeOpacity: 0.2,
    strokeDasharray: "4 10"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 200,
    width: 270,
    height: 130,
    rx: 20,
    fill: "url(#gprocess02)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 360,
    width: 180,
    height: 14,
    rx: 7,
    fill: "#548A85",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 392,
    width: 330,
    height: 14,
    rx: 7,
    fill: "#548A85",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 424,
    width: 240,
    height: 14,
    rx: 7,
    fill: "#548A85",
    fillOpacity: 0.28
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 480,
    width: 128,
    height: 42,
    rx: 21,
    fill: "#FF4804"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 250,
    r: 54,
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.55,
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 560,
    r: 34,
    fill: "#83ADA9",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess02);
export default __webpack_public_path__ + "static/media/process-02.626940cef6f2965d7ce3ad8eb347a897.svg";
export { ForwardRef as ReactComponent };